import styled from "styled-components";
import media from "constants/media";

export const DetailsStyled = styled.div`
    position: relative;
    z-index: 2;

    margin-bottom: 50px;

    ${media.mdUp`
        margin-bottom: 140px;
    `}
`;

export const Content = styled.div`
    max-width: 580px;
    margin: 0 auto;

    ${media.mdUp`
        max-width: 780px;
    `}
`;

export const Heading = styled.h2`
    margin-bottom: 36px;

    font-weight: normal;
    font-size: 35px;
    line-height: 40px;
    text-align: center;

    strong {
        font-weight: normal;
        font-family: var(--font-Agne);
    }

    ${media.mdUp`
        margin-bottom: 110px;

        font-size: 64px;
        line-height: 70px;
    `}
`;

export const Row = styled.div`
    margin-bottom: 40px;

    ${media.mdUp`
        display: flex;
        margin-bottom: 114px;
    `}
`;

export const Block = styled.div`
    margin-bottom: 20px;

    ${media.mdUp`
        width: 50%;
        margin-bottom: 0;

        &:first-child {
            padding-right: 10px;
        }

        &:last-child {
            padding-left: 10px;
        }
    `}
`;

export const Title = styled.h3`
    margin-bottom: 6px;

    font-weight: normal;
    font-size: 20px;
    line-height: 25px;

    ${media.mdUp`

        font-size: 24px;
        line-height: 30px;
    `}
`;

export const Text = styled.p`
    font-size: 14px;
    line-height: 20px;

    ${media.mdUp`
        font-size: 15px;
        line-height: 25px;
    `}
`;

export const Contact = styled.div`
    text-align: center;
`;
